import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReplay5Fill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M768 -128Q596 -128 441.0 -55.5Q286 17 177 149Q170 159 170.5 171.5Q171 184 179 192L316 330Q326 339 341 339Q357 337 364 327Q437 232 543.0 180.0Q649 128 768 128Q872 128 966.5 168.5Q1061 209 1130.0 278.0Q1199 347 1239.5 441.5Q1280 536 1280.0 640.0Q1280 744 1239.5 838.5Q1199 933 1130.0 1002.0Q1061 1071 966.5 1111.5Q872 1152 768 1152Q670 1152 580.0 1116.5Q490 1081 420 1015L557 877Q588 847 571 808Q554 768 512 768H64Q38 768 19.0 787.0Q0 806 0 832V1280Q0 1322 40 1339Q79 1356 109 1325L239 1196Q346 1297 483.5 1352.5Q621 1408 768 1408Q924 1408 1066.0 1347.0Q1208 1286 1311.0 1183.0Q1414 1080 1475.0 938.0Q1536 796 1536.0 640.0Q1536 484 1475.0 342.0Q1414 200 1311.0 97.0Q1208 -6 1066.0 -67.0Q924 -128 768 -128Z"
	})
});
export default SvgReplay5Fill;
